import React, { FunctionComponent, useEffect, useState } from 'react'
import * as yup from 'yup'
import useFormal from '@kevinwolf/formal-web'
import Grid from '@material-ui/core/Grid'
import SelectField from 'Elements/SelectField'
import { TextField } from 'components/elements/TextField'
import { SubmitButton } from 'Elements/SubmitButton'
import { useSubscriptionOffers } from 'SubscriptionOffers/SubscriptionOffersProvider'
import { ISubscriptionOffersListZoneData, useApi } from 'components/providers/ApiProvider'
import { useTranslation } from 'react-i18next'
import SearchIcon from '@material-ui/icons/Search'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import AddSubscriptionOfferDialog from 'SubscriptionOffers/partials/AddSubscriptionOfferDialog'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const Toolbar: FunctionComponent<AllProps> = ({}) => {
  const { t, i18n } = useTranslation()
  const api = useApi()
  const { filter, addZones, listLoading, onFilter } = useSubscriptionOffers()

  const [zones, setZones] = useState<ISubscriptionOffersListZoneData[]>([])
  const [openAddSubscriptionOfferDialog, setOpenAddSubscriptionOfferDialog] = useState(false)

  useEffect(() => {
    api.getSubscriptionOffersListZones()
      .then(data => {
        setZones(data.zones)
      })
      .catch(() => {
      })
  }, [])

  const schema = yup.object().shape({
    zone: yup.number(),
    type: yup.number(),
    client: yup.string().trim(),
  })

  const formal = useFormal(filter, {
    schema,
    onSubmit: async values => {
      if (listLoading) {
        return
      }

      onFilter(schema.cast(values))
    },
  })

  return (
    <>
      {Boolean(addZones.length) && (
        <Box marginTop={1} marginBottom={2}>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<AddIcon />}
            onClick={() => setOpenAddSubscriptionOfferDialog(true)}
          >
            {t('newSubscriptionOffer')}
          </Button>
        </Box>
      )}
      <form {...formal.getFormProps()}>
        <Grid container spacing={1} style={{ padding: '16px 0' }}>
          <SelectField
            GridProps={{ xs: 6, md: true }}
            label={t('zone')}
            optionsCustom={[
              {
                label: t('allZones'),
                id: 0,
              },
              ...zones.sort((a, b) => a.code.localeCompare(b.code)).map(zone => {
                const localization = zone.localizations.find(l => l.language == i18n.language)

                return {
                  label: `${zone.code}${localization && localization.name ? ` ${localization.name}` : ''}`,
                  id: zone.id,
                }
              }),
            ]}
            size="small"
            typeahead
            {...formal.getFieldProps('zone')}
            onChange={e => {
              formal.change('zone', e.target.value)
              formal.change('type', 0)
            }}
          />
          <SelectField
            GridProps={{ xs: 6, md: true }}
            label={t('type')}
            optionsCustom={[
              {
                label: t('allTypes'),
                id: 0,
              },
              ...((zones.find(z => z.id == formal.values.zone) || {}).types || []).map(type => ({
                label: type.name,
                id: type.id,
              })),
            ]}
            size="small"
            {...formal.getFieldProps('type')}
          />
          <TextField
            GridProps={{ xs: 12, md: true }}
            label={t('client')}
            size="small"
            {...formal.getFieldProps('client')}
          />
          <SubmitButton
            GridProps={{ xs: 12, md: 'auto' }}
            buttonText={t('search')}
            startIcon={<SearchIcon />}
            disabled={listLoading}
          />
        </Grid>
      </form>
      <AddSubscriptionOfferDialog open={openAddSubscriptionOfferDialog} setOpen={setOpenAddSubscriptionOfferDialog} />
    </>
  )
}

export default Toolbar
